export const dialerServers = [
    { key: 'firstngucc_db', label: 'NGUCC 15.15', type: 'ngucc' },
    { key: 'secondngucc_db', label: 'NGUCC 8.15', type: 'ngucc' },
    { key: 'thirdngucc_db', label: 'NGUCC 15.30', type: 'ngucc' },
    { key: 'fourthngucc_db', label: 'NGUCC 17.4', type: 'ngucc' },
    { key: 'fifthconvox_db', label: 'Convox 15.50', type: 'convox' },
    { key: 'sixthconvox_db', label: 'Convox 15.51', type: 'convox' },
    { key: 'verbngucc_db', label: 'Verb 8.20', type: 'verb' },
    { key: 'verbnguccsecond_db', label: 'Verb 8.22', type: 'verb' },
    { key: 'verbnguccthird_db', label: 'Verb 15.38', type: 'verb' },
];

export const todayInIndia = () => {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date());
    const value = type => parts.find(part => part.type === type).value;
    return `${value('year')}-${value('month')}-${value('day')}`;
};
